import { OptionPanelRow, Switch } from "@salestrak/ui";

import { useTrackViewOption, useViews } from "#app/lib/views/view-context";

/**
 * The Display group's "Collapse empty stages" switch. It reads the draft
 * config itself so any body can seat it among its own rows — the main page
 * renders it where a body offers no Display rows, and a body that does (the
 * board) places it with its other switches.
 */
export function CollapseEmptyStagesRow() {
  const { config, setConfig } = useViews();
  const trackOption = useTrackViewOption();
  // Empty buckets only mean something for a grouping whose buckets are a
  // bounded, ordered set — an assignee grouping has no empty bucket to show.
  // A draft edit, so open to every viewer — without `create.views` it is
  // temporary.
  const groupsAreBounded = config.groupBy === "stage";
  const disabled = !groupsAreBounded;
  return (
    <OptionPanelRow
      label="Collapse empty stages"
      disabled={disabled}
      hint={groupsAreBounded ? undefined : "Only while grouping by stage"}
    >
      <Switch
        size="sm"
        checked={config.collapseEmptyStages}
        disabled={disabled}
        // Moving the switch resets the empty stages a person had opened by
        // hand (`expandedGroups`): the toggle is the statement "empty stages
        // start closed", and a stale override would exempt one stage from it
        // until someone noticed. Re-opening and saving re-creates the override.
        onCheckedChange={(checked) => {
          setConfig({ collapseEmptyStages: !!checked, expandedGroups: [] });
          trackOption("collapseEmptyStages", { on: !!checked });
        }}
      />
    </OptionPanelRow>
  );
}
